import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const openUserRoleModalAction = createAsyncThunk(
  'modals/openUserRoleModal',
  (data) => {
    return data
  }
)

export const openTaskModalAction = createAsyncThunk(
  'modals/openTaskModal',
  (data) => {
    return data
  }
)
export const openTagModalAction = createAsyncThunk(
  'modals/openTagModal',
  (data) => {
    return data
  }
)

export const openTaskTagsModalAction = createAsyncThunk(
  'modals/openTaskTagsModal',
  (data) => {
    return data
  }
)

export const openLinkModalAction = createAsyncThunk(
  'modals/openLinkModal',
  (data) => {
    return data
  }
)

export const openTemplatesModalAction = createAsyncThunk(
  'modals/openTemplatesModal',
  (data) => {
    return data
  }
)

export const openTemplatesSelectModalAction = createAsyncThunk(
  'modals/openTemplatesSelectModal',
  (data) => {
    return data
  }
)

const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    userRole: null,
    TaskForm: {
      defaultType: null,
      defaultEpicBy: null,
      open: false,
      title: 'Редактирование задачи',
      defaultRelatedBy: null,
      eventType: null,
      defaultTaskDetails: null,
      stage: null,
      checklistPointTitle: null,
    },
    tag: {
      open: false,
      title: 'Теги',
    },
    taskTags: {
      open: false,
      title: 'Добавление тегов',
    },
    link: {
      title: null,
      type: null,
      open: false,
    },
    templates: {
      open: false,
      title: null,
      templateId: null,
      type: null,
    },
    templatesSelect: {
      open: false,
      title: 'Шаблоны',
      templates: null,
    },
  },
  reducers: {
    closeUserRoleModal: (state) => {
      state.userRole = null
    },
    closeTaskForm: (state) => {
      state.TaskForm = {
        open: false,
        defaultType: null,
        defaultEpicBy: null,
        defaultRelatedBy: null,
        updateRequest: null,
        defaultTaskDetails: null,
        title: null,
        eventType: null,
        openTask: null,
      }
    },
    closeTagModal: (state) => {
      state.tag = {
        open: false,
      }
    },
    closeTaskTagsModal: (state) => {
      state.taskTags = { ...state.taskTags, open: false }
    },

    closeTemplatesModal: (state) => {
      state.templates = {
        ...state.templates,
        open: false,
        title: null,
        templateId: null,
        type: null,
      }
    },
    closeTemplatesSelectModal: (state) => {
      state.templatesSelect = {
        ...state.templatesSelect,
        open: false,
        templates: null,
        title: null,
      }
    },
    closeLinkModal: (state) => {
      state.link = {
        open: false,
        type: null,
        title: null,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(openUserRoleModalAction.fulfilled, (state, action) => {
      state.userRole = {
        open: true,
        title: 'Участники проекта',
        projectSlug: action.payload.projectSlug,
      }
    })
    builder.addCase(openTaskModalAction.fulfilled, (state, action) => {
      state.TaskForm = {
        open: true,
        defaultTaskDetails: action.payload.defaultTaskDetails,
        defaultType: action.payload.defaultType,
        defaultEpicBy: action.payload.defaultEpicBy,
        updateRequest: action.payload.updateRequest,
        openTask: action.payload.openTask,
        eventType: action.payload.eventType || 'create',
        defaultRelatedBy: action.payload.defaultRelatedBy,
        title: action.payload.title,
        stage: action.payload.stage,
        checklistPointTitle: action.payload.checklistPointTitle,
      }
    })
    builder.addCase(openTagModalAction.fulfilled, (state) => {
      state.tag = {
        open: true,
      }
    })
    builder.addCase(openTaskTagsModalAction.fulfilled, (state) => {
      state.taskTags = { ...state.taskTags, open: true }
    })
    builder.addCase(openLinkModalAction.fulfilled, (state, action) => {
      state.link = {
        title: action.payload.title,
        type: action.payload.type,
        open: true,
      }
    })
    builder.addCase(openTemplatesModalAction.fulfilled, (state, action) => {
      state.templates = {
        ...state.templates,
        open: true,
        title: action.payload.title,
        templateId: action.payload.templateId,
        type: action.payload.type,
      }
    })
    builder.addCase(
      openTemplatesSelectModalAction.fulfilled,
      (state, action) => {
        state.templatesSelect = {
          ...state.templatesSelect,
          open: true,
          templates: action.payload.templates,
        }
      }
    )
  },
})

export const {
  closeUserRoleModal,
  closeTagModal,
  closeTaskTagsModal,
  closeTemplatesModal,
  closeTemplatesSelectModal,
  closeLinkModal,
  closeTaskForm,
} = modalsSlice.actions

export const taskModalSelector = (state) => state.modals.TaskForm
export const userRoleModalSelector = (state) => state.modals.userRole
export const tagModalSelector = (state) => state.modals.tag
export const taskTagsModalSelector = (state) => state.modals.taskTags
export const templatesModalSelector = (state) => state.modals.templates
export const templatesSelectModalSelector = (state) =>
  state.modals.templatesSelect
export const linkModalSelector = (state) => state.modals.link

export default modalsSlice.reducer
